import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { User } from '../core/users/users.model';
import { UserActionService } from '../core/users/users.action';

@Injectable()
export class SingleUserResolver implements Resolve<User> {
  @select(['user', 'list'])
  userList$: Observable<User[]>;
  isUserInRedux = false;

  constructor(private service: ApiService,
              private userAction: UserActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.userList$.pipe(
      first(),
      mergeMap((list) => {
        const actualRoute = state.url;
        const idFromUrl = parseInt(actualRoute.split('/').pop(), 10);
        if (list.length > 0) {
          this.isUserInRedux = true;
          return of(list.find(({id}) => id === idFromUrl));
        }
        return this.service.userDetail(idFromUrl).pipe(first());
      }),
      tap((data: any) => {
        const userCurrent = this.isUserInRedux ?
          data :
          User.from(data);
        this.userAction.setUserCurrent(userCurrent);
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare il singolo utente');
        return of(err);
      })
    );
  }
}
